import { createSelector } from 'reselect';

const institutionsSelector = (state) => state.institutions;

export const selectOrgAliases = createSelector(
  [institutionsSelector],
  (institutions) => institutions.aliases
);

export const selectInstitutionId = createSelector(
  [institutionsSelector],
  (institutions) => institutions.institutionInfo.id
);

export const selectInstitution = createSelector(
  [institutionsSelector],
  (institutions) => institutions.institutionInfo
);

export const selectPortalSettings = createSelector(
  [institutionsSelector],
  (institutions) => institutions.portalSettings
);

export const selectIsSet = createSelector(
  [institutionsSelector],
  (institutions) => institutions.isSet
);

export const savingInstitutionInfo = createSelector(
  [institutionsSelector],
  (institutions) => institutions.savingInstitutionInfo
);

export const savingContact = createSelector(
  [institutionsSelector],
  (institutions) => institutions.savingContactInfo
);

export const checkingOrgLoading = createSelector(
  [institutionsSelector],
  (institutions) => institutions.isCheckingOrg
);

export const checkingOrgError = createSelector(
  [institutionsSelector],
  (institutions) => institutions.isCheckingOrgError
);

export const fetchingReminders = createSelector(
  [institutionsSelector],
  (institutions) => institutions.fetchingReminders
);

export const remindersSettings = createSelector(
  [institutionsSelector],
  (institutions) => institutions.reminders
);

export const savingReminderSettings = createSelector(
  [institutionsSelector],
  (institutions) => institutions.savingReminder
);

export const edittingReminderSettings = createSelector(
  [institutionsSelector],
  (institutions) => institutions.edittingReminder
);

export const deletingReminderSettings = createSelector(
  [institutionsSelector],
  (institutions) => institutions.deletingReminder
);

export const fetchingSchedule = createSelector(
  [institutionsSelector],
  (institutions) => institutions.fetchingSchedule
);

export const emailReportScheduleSettings = createSelector(
  [institutionsSelector],
  (institutions) => institutions.schedule
);

export const deletingSchedule = createSelector(
  [institutionsSelector],
  (institutions) => institutions.deletingSchedule
);

export const editingSchedule = createSelector(
  [institutionsSelector],
  (institutions) => institutions.edittingSchedule
);

export const imgCacheClearerSelector = createSelector(
  [institutionsSelector],
  (institutions) => institutions.imgCacheClearer
);



export const fetchingOrgBranches = createSelector(
  [institutionsSelector],
  (institutions) => institutions.fetchingOrgBranches
);

export const orgBranches = createSelector(
  [institutionsSelector],
  (institutions) => institutions.orgBranches
);

export const savingOrgBranch = createSelector(
  [institutionsSelector],
  (institutions) => institutions.savingOrgBranch
);

export const edittingOrgBranch = createSelector(
  [institutionsSelector],
  (institutions) => institutions.edittingOrgBranch
);

export const deletingOrgBranch = createSelector(
  [institutionsSelector],
  (institutions) => institutions.deletingOrgBranch
);